import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppState {
  selectedCourseInfo: any;
  sidebarCollapsed: boolean;
}

interface AppStateContextType {
  state: AppState;
  setSelectedCourse: (course: any) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setActiveTab: (tab: string) => void;
  invalidateCache: () => void;
}

const AppStateContext = createContext<AppStateContextType | undefined>(undefined);

export const useAppState = () => {
  const context = useContext(AppStateContext);
  if (!context) {
    throw new Error('useAppState must be used within an AppStateProvider');
  }
  return context;
};

interface AppStateProviderProps {
  children: ReactNode;
}

export const AppStateProvider: React.FC<AppStateProviderProps> = ({ children }) => {
  const [state, setState] = useState<AppState>({
    selectedCourseInfo: null,
    sidebarCollapsed: false,
  });

  const setSelectedCourse = (course: any) => {
    setState(prev => ({ ...prev, selectedCourseInfo: course }));
  };

  const setSidebarCollapsed = (collapsed: boolean) => {
    setState(prev => ({ ...prev, sidebarCollapsed: collapsed }));
  };

  const setActiveTab = (_tab: string) => {
    // No-op for booking service
  };

  const invalidateCache = () => {
    // No-op for booking service
  };

  const value: AppStateContextType = {
    state,
    setSelectedCourse,
    setSidebarCollapsed,
    setActiveTab,
    invalidateCache,
  };

  return (
    <AppStateContext.Provider value={value}>
      {children}
    </AppStateContext.Provider>
  );
};
